import {subdebug} from '@sanity/cli-core'

export const updateCheckerDebug = subdebug('updateChecker')
